import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getMaterialRequests(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${registrationId}/material-requests?` + parameters
  );
  return data;
}

export async function getAllMaterialRequests(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`/material-requests?` + parameters);
  return data;
}

export async function getMaterialRequest(registrationId, id) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/material-requests/` + id
  );
  return data;
}

export async function updateMaterialRequest(registrationId, id, values) {
  const { data } = await axios.put(
    `/registrations/${registrationId}/material-requests/${id}`,
    values
  );
  return data;
}

export async function createMaterialRequest(registrationId, values) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/material-requests`,
    values
  );
  return data;
}

export async function deleteMaterialRequest(registrationId, id) {
  const { data } = await axios.delete(
    `/registrations/${registrationId}/material-requests/` + id
  );
  return data;
}

export async function syncMaterialRequestDays(
  registrationId,
  materialRequestId,
  values
) {
  const { data } = await axios.put(
    `/registrations/${registrationId}/material-requests/${materialRequestId}/material-request-days`,
    values
  );
  return data;
}

export async function updateMaterialRequestDay(
  registrationId,
  materialRequestId,
  materialRequestDayId,
  values
) {
  const { data } = await axios.put(
    `/registrations/${registrationId}/material-requests/${materialRequestId}/material-request-days/${materialRequestDayId}`,
    values
  );
  return data;
}

export async function approveMaterialRequest(
  registrationId,
  materialRequestId,
  values
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/material-requests/${materialRequestId}/approve`,
    values
  );
  return data;
}

export async function rejectMaterialRequest(
    registrationId,
    materialRequestId,
    values
) {
  const { data } = await axios.post(
      `/registrations/${registrationId}/material-requests/${materialRequestId}/reject`,
      values
  );
  return data;
}
